<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <h4 qid="maintenance-create-dd-title">
      {{$t('maintenance.data_discovery.create.title')}}
    </h4>

    <div class="card">
      <div class="card-body">
        <div class="form-centered">
          <b-alert v-if="error.length"
                   show
                   variant="danger"
                   qid="create-dd-error"
          >
            {{ error }}
          </b-alert>
          <b-form @submit="formSubmit" qid="create-dd-form">
            <div class="form-container">
              <b-form-group>
                <label qid="create-dd-name-label">
                  {{ $t('maintenance.data_discovery.create.name_label') }}
                </label>
                <b-form-input
                  qid="create-dd-form-name"
                  type="text"
                  v-model="ddForm.name"
                  required
                  :maxLength="255"
                  :placeholder="$t('maintenance.data_discovery.create.name_placeholder')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-dd-collection-label">
                  {{ $t('maintenance.data_discovery.create.data_scanning_label') }}
                </label>
                <b-form-radio-group
                  v-model="ddForm.data_scanning"
                  :options="radioOptions"
                  qid="create-dd-form-collection"
                ></b-form-radio-group>
              </b-form-group>
            </div>
            <div class="text-right">
              <b-button class="mt-3"
                        variant="secondary"
                        @click="goToList"
                        qid="create-dd-cancel-button"
              >
                {{ $t('maintenance.data_discovery.create.cancel') }}
              </b-button>
              <b-button type="submit"
                        class="mt-3 ml-3"
                        :disabled="buttonDisabled"
                        variant="success"
                        qid="create-dd-submit-button"
              >
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </span>
                {{ $t('maintenance.data_discovery.create.submit') }}
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'CreateDataDiscovery',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('maintenance.title'),
            to: '/maintenance'
          },
          {
            text: this.$t('maintenance.data_discovery.title'),
            to: '/maintenance/data-discovery'
          },
          {
            text: this.$t('maintenance.data_discovery.create.title'),
            active: true
          }
        ],
        ddForm: {
          name: '',
          data_scanning: '',
          client:'',
        },
        error: '',
        radioOptions: [
          {text: this.$t('system.yes'), value: 1},
          {text: this.$t('system.no'), value: 0}
        ],
        buttonDisabled: false
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getFiles() {
        return this.selectedFiles
      }
    },
    methods: {
      goToList() {
        this.$router.push('/maintenance/data-discovery')
      },
      formSubmit(evt) {
        this.buttonDisabled = true;
        let formData = new FormData();

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        formData.append("name", this.ddForm.name);
        formData.append("data_scanning", this.ddForm.data_scanning);
        formData.append("client", this.getClient.slug);

        // Post FormData object to API
        piincHttp.post('/data-discoveries', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function(response) {
          self.$toastr('success', self.$t('maintenance.data_discovery.create.success'))
          self.buttonDisabled = false;
          self.goToList();
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            // Print whole array of actual errors beside message
            self.error = self.error + '\n\n' + JSON.stringify(error.data.errors);
          }
        })
      }
    },
    components: {

    },
    created () {

    }
  }
</script>
